<template>
	<div class="px-4 text-center relative">
		<h1 class="text-3xl font-semibold leading-none sm:text-4xl xl:text-5xl">DISH Outdoors In 3 Easy Steps</h1>
		<p class="mt-2 text-xl leading-tight sm:text-2xl xl:text-3xl sm:max-w-md sm:mx-auto lg:max-w-full">Your way to take TV outside whenever and where you want to!</p>

		<div class="lg:flex lg:-ml-8 lg:px-4">
			<div v-for="(video, index) in videos" :key="index" class="block max-w-md mx-auto pb-5 mt-12 lg:mt-8 lg:ml-8 lg:flex-1">
				<div class="shadow-md relative pb-4 xl:h-full">
					<div class="w-full relative" style="padding-bottom: 56.25%;">
						<iframe class="absolute w-full h-full" :src="video.link" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen />
					</div>

					<div class="px-4 py-4">
						<div class="absolute bottom-0 w-full left-0 flex justify-center -mb-5">
							<p class="text-2xl font-bold bg-dish-red text-white rounded-full w-8 h-8 flex justify-center items-center flex-shrink-0 lg:h-10 lg:w-10 lg:text-3xl">
								<span class="-mt-1 leading-none">{{ index + 1 }}</span>
							</p>
						</div>
						<div class="flex justify-center items-center lg:items-start">
							<h3 class="tracking-tight text-lg font-bold leading-none lg:text-xl xl:text-2xl xl:max-w-xs">{{ video.title }}</h3>
						</div>
						<p class="leading-tight mt-2 xl:text-xl">{{ video.description }}</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script lang="ts">
	import { defineComponent } from 'vue'

	export default defineComponent({
		setup() {
			const videos: Array<{
				link: string,
				title: string,
				description: string,
			}> = [{
					link: 'https://www.youtube.com/embed/0Oleb0NVeek?rel=0&modestbranding=1&enablejsapi=1',
					title: 'Choose a DISH-compatible satellite antenna.',
					description: 'Portable, automatic, HD satellite antennas for your adventures.',
				}, {
					link: 'https://www.youtube.com/embed/bTkb3GmdHZ4?rel=0&modestbranding=1&enablejsapi=1',
					title: 'Add a DISH Wally® HD receiver.',
					description: 'Bundle a receiver with your antenna for even more savings.',
				}, {
					link: 'https://www.youtube.com/embed/8VbPUaovRSw?rel=0&modestbranding=1&enablejsapi=1',
					title: 'Call 1-877-790-1540 to activate.',
					description: 'Pay As You Go from $52.99/mo*, with no contracts or commitments.',
				}]

			return {
				videos,
			}
		},
	})
</script>
